import { MAX_ITEMS_IN_CAROUSEL, getSlidesToShow } from '../helper'

export const getCarouselSettings = (variants) => ({
  dots: false,
  infinite: false,
  className: 'carousel-variant-carousel__container carousel-variant-carousel__container--five-items-desktop',
  speed: 500,
  slidesToShow: getSlidesToShow(5, variants),
  slidesToScroll: 1,
  arrows: variants.length > MAX_ITEMS_IN_CAROUSEL,
  responsive: [
    {
      breakpoint: 1290,
      settings: {
        slidesToShow: getSlidesToShow(4, variants),
        className: 'carousel-variant-carousel__container--four-items-desktop',
      },
    },
    {
      breakpoint: 1040,
      settings: {
        slidesToShow: getSlidesToShow(3, variants),
        className: 'carousel-variant-carousel__container--three-items-desktop',
      },
    },
    {
      breakpoint: 830,
      settings: {
        slidesToShow: getSlidesToShow(2, variants),
        className: 'carousel-variant-carousel__container--two-items-desktop',
      },
    },
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        slidesToShow: getSlidesToShow(5, variants),
        className: 'carousel-variant-carousel__container--five-items-mobile',
      },
    },
    {
      breakpoint: 690,
      settings: {
        arrows: false,
        slidesToShow: getSlidesToShow(4, variants),
        className: 'carousel-variant-carousel__container--four-items-mobile',
      },
    },
    {
      breakpoint: 600,
      settings: {
        arrows: false,
        slidesToShow: getSlidesToShow(3, variants),
        className: 'carousel-variant-carousel__container--three-items-mobile',
      },
    },
    {
      breakpoint: 400,
      settings: {
        arrows: false,
        slidesToShow: getSlidesToShow(2, variants),
        className: 'carousel-variant-carousel__container--two-items-mobile',
      },
    },
  ],
})
